import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const METHOD_COLORS = {
  'Efectivo': '#ffa726',
  'Tarjeta Crédito': '#42a5f5',
  'Tarjeta Débito': '#66bb6a',
  'MercadoPago': '#1976d2',
  'PedidosYa': '#ef5350',
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      {payload.map((entry, index) => (
        <Typography key={index} variant="body2">
          {entry.name}: {formatMoney(entry.value)}
        </Typography>
      ))}
    </Box>
  );
};

const PaymentMethodsByBranchChart = ({ data, branches, loading }) => {
  if (loading) {
    return (
      <Paper elevation={2} sx={{ p: 2, height: 300 }}>
        <Typography variant="subtitle1" gutterBottom>
          Métodos de pago por sucursal
        </Typography>
        <Skeleton variant="rectangular" height={240} />
      </Paper>
    );
  }

  // Transform data for BarChart
  const chartData = data.map((branch) => {
    const branchName = branches.find((b) => b.id === branch.branchId)?.name || `Sucursal ${branch.branchId}`;
    return {
      name: branchName,
      ...branch.methods,
    };
  });

  return (
    <Paper elevation={2} sx={{ p: 2, height: 340 }}>
      <Typography variant="subtitle1" gutterBottom>
        Métodos de pago por sucursal
      </Typography>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={chartData} margin={{ top: 20, right: 20, bottom: -40, left: 10 }}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          {Object.entries(METHOD_COLORS).map(([method, color]) => (
            <Bar key={method} dataKey={method} stackId="a" fill={color} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default PaymentMethodsByBranchChart;
